var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarningCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 0-.338.005C5.163.192 0 5.5 0 12l.004.308C.192 18.837 5.5 24 12 24l.308-.004C18.833 23.807 24 18.495 24 12l-.004-.308C23.807 5.167 18.495 0 12 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.32 0 9.687 4.16 9.984 9.441l.012.28L22 12c0 5.32-4.16 9.687-9.441 9.984l-.28.012L12 22a9.996 9.996 0 0 1-9.984-9.441l-.012-.28L2 12a9.996 9.996 0 0 1 9.441-9.984l.28-.012L12 2z",
    fill: "#F00022",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5a1 1 0 0 1 .993.883L13 7.5v5a1 1 0 0 1-1.993.117L11 12.5v-5a1 1 0 0 1 1-1zm-.001 8.5.117.006a1.254 1.254 0 0 1 1.133 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarningCircleFill);
export default __webpack_public_path__ + "static/media/icons-warning-circle-fill.42afd834de8c2fdc229d8d75154ee84b.svg";
export { ForwardRef as ReactComponent };